<template>
  <div class="input-wrapper">
    <div class="input-label" :class="{'with-notice': isHaveNotice || isHaveLinkNotice}" v-if="label">
      <div class="label-text">{{ label }}</div>
      <div v-if="isHaveNotice" class="notice">
        ?
        <div class="notice-msg">
          {{ noticeMessage }}
          <img
            class="notice-arrow"
            src="../../../public/custom/images/notice-arrow.svg"
            alt="Notice arrow"
          />
        </div>
      </div>

      <div v-if="isHaveLinkNotice" class="link-notice" @click="goToNoticeLink()">
        ?
      </div>
    </div>
    <div class="input-block" :class="{ invalid: errors.has(validateRules) }">
      <input
        class="input"
        :type="type"
        v-model="inputValue"
        :placeholder="placeholder"
        :maxlength="maxLength"
        :name="name"
        @input="$emit('input', inputValue)"
        @paste="$emit('input', inputValue)"
        @maska="$emit('input', $event.target.dataset.maskRawValue)"
        v-validate="validateRules"
        v-maska="maskPattern"
        :disabled="disabled"
      />
    </div>
    <div class="error-block">{{ errorMessage }}</div>
  </div>
</template>

<script>
export default {
  name: "BaseTextInput",
  props: {
    label: String,
    isHaveNotice: {
      type: Boolean,
      default: false,
    },
    isHaveLinkNotice: {
      type: Boolean,
      default: false,
    },
    linkNoticePath: String,
    noticeMessage: String,
    defaultValue: String,
    placeholder: String,
    maxLength: Number,
    name: String,
    validateRules: String,
    maskPattern: String,
    disabled: Boolean,
    type: {
      type: String,
      default() {
        return 'text';
      }
    }
  },
  data() {
    return {
      inputValue: "" || this.defaultValue,
    };
  },
  methods: {
    goToNoticeLink() {
      if (this.linkNoticePath) {
        this.$router.push(this.linkNoticePath);
      }
    }
  },
  computed: {
    errorMessage() {
      return this.errors.first(this.validateRules);
    },
  },
  watch: {
    defaultValue(value) {
      this.inputValue = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
    @include base-input-wrapper;
}

.input-label {
    @include base-input-label;
}

.with-notice {
  display: flex;
  margin-bottom: 8px;
}

.mt1 {
    margin-top: 1px;
}

.notice {
    @include base-input-notice;
    margin-left: 5px;

    &:hover {
        .notice-msg {
            display: block;
        }
    }
}

.link-notice {
  @include base-input-notice;
  margin-left: 5px;

  color: #41BF7B;
  border-color: #41BF7B;
}

.input-block {
    @include base-input-block;
}

.input {
    @include base-input;
}

.invalid {
    border-color: var(--base-input-invalid-border-bgc);
}

.error-block {
    @include base-input-error-block;
}

.notice-msg {
    @include base-notice-msg;
}

.notice-arrow {
    position: absolute;
    bottom: -3px;
    left: 11px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
    -moz-appearance:textfield; /* Firefox */
}
</style>
